import { useMutation } from "react-query";
import http from "shared/http";

export interface ReportResource {
  id: number;
  title: string;
  resourceTier?: string;
  summary?: string;
  categories: string[];
  agencies?: string[];
  roles?: string[];
  isActive?: boolean;

  tenantId?: string;
  workspaceId?: string;
  reportId?: string;
  datasetId?: string;
  requiresEffectiveIdentity?: boolean;

  defaultPageName?: string;
  pbiRoles?: string;
}

export const useUpsertReportMutation = () => {
  return useMutation(async (report: ReportResource) => {
    if (report.id > 0) {
      return await http.putAsync(`admin/reports/${report.id}`, report);
    }
    return await http.postAsync("admin/reports", report);
  });
};

export const useDeleteReportMutation = () => {
  return useMutation(async (reportId: number) => {
    return await http.deleteAsync("admin/reports", reportId);
  });
};
